import axios from 'axios'
import AuthService from './auth-header'

let API_URL = ''
if (process.env.NODE_ENV === "production") {
  API_URL = 'https://ats.sattvahuman.in/api/'
} else {
  API_URL = 'http://192.168.0.30:5000/api/'
}

const defaultPagination = () => ({
  currentPage: 1,
  totalPages: 1,
  totalRecords: 0,
  limit: 100,
  hasNextPage: false,
  hasPreviousPage: false,
  previousPage: null,
  nextPage: null,
})

const emptyCandidatesResponse = () => ({
  status: 'OK',
  data: [],
  total: 0,
  pagination: defaultPagination(),
  statusWise: [],
  latestRecords: [],
})

const transformCandidate = candidate => ({
  id: candidate.cid,
  job_id: candidate.jid,
  candidate_name: candidate.candidate_name,
  position_name: candidate.position_name,
  contact_no: candidate.contact_no,
  email: candidate.email,
  candidateStatus: candidate.candidateStatus,
  assignedTo: candidate.recruiter,
  recruiter: candidate.recruiter,
  'Employee Name': candidate['Employee Name'] || null,
  account_mgr: candidate.account_mgr,
  locations: candidate.locations,
  pref_location: candidate.pref_location || candidate.curr_location,
  position_type: candidate.position_type,
  payroll: candidate.payroll,
  category: candidate.category,
  vertical: candidate.vertical,
  client: candidate.client,
  source: candidate.source,
  status: candidate.status,
  rec_id: candidate.rec_id,
  sourcer_id: candidate.sourcer_id,
  mgr_id: candidate.mgr_id,
  sourcer: candidate.sourcer,
  attachments: candidate.attachments,
  selection_date: candidate.selection_date,
  offered_date: candidate.offered_date,
  offered_ctc: candidate.offered_ctc,
  joining_date: candidate.joining_date,
  createdAt: candidate.createdAt,
  updatedAt: candidate.updatedAt,
  business: candidate.business,
  extra_details: candidate.extra_details,
  offerProcess: candidate.offerProcess,
  documents: candidate.documents,
  offerDetails: candidate.candidateStatus === 'Offered' ? {
    candidateName: candidate.candidate_name,
    emailId: candidate.email,
    joiningDate: candidate.joining_date,
    offeredDate: candidate.offered_date,
    site: 'assam',
    language: 'en',
  } : null,
})

class ClientDashboardService {
  async getClientCandidates(clientName, params = {}) {
    try {
      const response = await axios.get(`${API_URL}dashboard/client/${clientName}`, {
        params: {
          status: params.status,
          assignedTo: params.assignedTo,
          search: params.search,
          page: params.page || 1,
          limit: params.limit || 100,
        },
        headers: AuthService.authHeader(),
      })

      if (!response.data || response.data.status !== 'OK') {
        const errorMessage = response.data?.message || 'Failed to fetch candidates'
        throw new Error(errorMessage)
      }

      if (!response.data.data) {
        return emptyCandidatesResponse()
      }

      const allCandidatesFromAPI = [
        ...(response.data.data.candidates || []),
        ...(response.data.data.latestRecords || []),
      ]

      if (allCandidatesFromAPI.length === 0) {
        return {
          status: 'OK',
          data: [],
          total: response.data.data.pagination?.totalRecords || 0,
          pagination: response.data.data.pagination || defaultPagination(),
          statusWise: response.data.data.statusWise || [],
          latestRecords: [],
        }
      }

      const transformedCandidates = allCandidatesFromAPI.map(transformCandidate)

      return {
        status: response.data.status,
        data: transformedCandidates,
        total: response.data.data.pagination?.totalRecords || transformedCandidates.length,
        pagination: response.data.data.pagination || {
          ...defaultPagination(),
          totalRecords: transformedCandidates.length,
        },
        statusWise: response.data.data.statusWise || [],
        latestRecords: transformedCandidates,
      }
    } catch (error) {
      console.error(`Error fetching ${clientName} candidates:`, error)
      return {
        status: 'ERROR',
        data: [],
        total: 0,
        pagination: defaultPagination(),
        statusWise: [],
        latestRecords: [],
      }
    }
  }

  checkDocumentsAvailable(candidate) {
    if (candidate.documents) {
      const requiredDocs = ['aadhaar', 'pan', 'photo', 'bankProof']
      return requiredDocs.every(doc =>
        candidate.documents[doc]
        && candidate.documents[doc].trim() !== ''
        && candidate.documents[doc] !== null)
    }

    return false
  }
}

export default new ClientDashboardService()
